var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarmLightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(.833 1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#2F92D0",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M0 17.417L9.146 0 18.292 17.417zM9.146 7.333V11"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.146,
    cy: 13.75,
    r: 1,
    fill: "#2F92D0",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmLightBlue);
export default __webpack_public_path__ + "static/media/alarm-light-blue.ebc0d7ba43a8bad0d04dc289a1033738.svg";
export { ForwardRef as ReactComponent };